import { render, staticRenderFns } from "./OneProductsListing.vue?vue&type=template&id=4c879188&scoped=true&"
import script from "./OneProductsListing.vue?vue&type=script&lang=ts&"
export * from "./OneProductsListing.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductsListing.vue?vue&type=style&index=0&id=4c879188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c879188",
  null
  
)

export default component.exports